import { render } from "./CatalogAttributeItemSingleAutocomplete.vue?vue&type=template&id=6d2fbdd2&scoped=true"
import script from "./CatalogAttributeItemSingleAutocomplete.vue?vue&type=script&lang=js"
export * from "./CatalogAttributeItemSingleAutocomplete.vue?vue&type=script&lang=js"

import "./CatalogAttributeItemSingleAutocomplete.vue?vue&type=style&index=0&id=6d2fbdd2&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2fbdd2"]])

export default __exports__